// import { Analytics } from '@/utils/analytics';

export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

declare global {
  interface Window {
    dynamicEnvConfig?: Partial<Config>;
  }
}

export interface Config {
  version: string;
  sentryDsn: string;
  fullStoryOrgId: string;
  production: boolean;
  environment: string;
  consoleLogsEnabled: boolean;
  // analytics: Parameters<(typeof Analytics)['init']>[0];
  dataDog: {
    shouldInit: boolean;
    appId: string;
    clientId: string;
    site: string;
    service: string;
  };
}

const defaultConfig: Config = {
  environment: 'development',
  version: '1.0.0',
  production: false,
  sentryDsn: '',
  fullStoryOrgId: '10BZN1',
  consoleLogsEnabled: true,
  // analytics: {
  //   reportEvents: true,
  //   printEvents: true,
  //   segmentKey: '',
  // },
  dataDog: {
    shouldInit: false,
    appId: '<your-datadog-app-id>',
    clientId: '<your-datadog-client-id>',
    site: 'datadoghq.com',
    service: 'developers-portal',
  },
};

const getEnvConfig = (env: string): Partial<Config> => {
  // Development - use default
  if (env === 'development') {
    return {};
  }

  // Production
  if (env === 'production') {
    return {
      consoleLogsEnabled: false,
      // analytics: {
      //   reportEvents: true,
      //   printEvents: false,
      //   segmentKey: '',
      // },
      dataDog: {
        shouldInit: true,
        appId: '<your-datadog-app-id>',
        clientId: '<your-datadog-client-id>',
        site: 'datadoghq.com',
        service: 'developers-portal',
      },
    };
  }

  // Non-prod environments (eilat, staging01, int02, etc.)
  return {
    dataDog: {
      shouldInit: true,
      appId: '<your-datadog-app-id>',
      clientId: '<your-datadog-client-id>',
      site: 'datadoghq.com',
      service: 'developers-portal',
    },
  };
};

const baseConfig: Config = { ...defaultConfig, ...window.dynamicEnvConfig };
const envConfig = getEnvConfig(baseConfig.environment);

export const config: Config = { ...baseConfig, ...envConfig };
